import { SelectIntegrationTypeWebView } from '../view/SelectIntegrationTypeWebView';
import { templateSelectIntegrationType } from '../view/template';
import { BaseWebComponentController } from '../../../framework/BaseWebComponentController';
import { SelectIntegrationTypeWebComponent } from '../component/SelectIntegrationTypeWebComponent';

export class SelectIntegrationTypeWebController extends BaseWebComponentController {
  public component: SelectIntegrationTypeWebComponent;
  public view: SelectIntegrationTypeWebView;
  public viewConstructor: typeof SelectIntegrationTypeWebView;

  constructor(component: SelectIntegrationTypeWebComponent) {
    super(component);

    this.initialSetup({
      viewConstructor: SelectIntegrationTypeWebView,
      viewTemplate: templateSelectIntegrationType,
    });
  }

  public async getDataForView(): Promise<any> {
    return {
      licenses: this.component.licenses,
    };
  }
}
